export default __webpack_public_path__ + "static/media/interior-1.12b4386d.jpg";